import { atom, selector } from 'recoil';

import { UploadedFile } from 'types';
import { responseDetailState, responseTypeIdState } from './responseForm';

export const responseFilesState = atom<UploadedFile[] | undefined>({
  key: 'responseFiles',
  default: undefined,
});

export const responseSupportingFilesState = atom<UploadedFile[] | undefined>({
  key: 'responseSupportingFiles',
  default: undefined,
});

export const responseUploadRequiredState = atom<boolean | undefined>({
  key: 'uploadRequired',
  default: true,
});

export const useResponseFilesState = selector({
  key: 'responseFilesState',
  get: ({ get }) => {
    return {
      responseTypeId: get(responseTypeIdState),
      responseDetail: get(responseDetailState),
      responseFiles: get(responseFilesState),
      supportingFiles: get(responseSupportingFilesState),
      requiredFiles: get(responseUploadRequiredState),
    };
  },
});
